import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export const MobileCTABar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section
      const heroHeight = document.getElementById('hero')?.offsetHeight || 0;
      setIsVisible(window.scrollY > heroHeight);
      // Hide when reaching the footer
      const footerTop = document.querySelector('footer')?.offsetTop || 0;
      const windowBottom = window.scrollY + window.innerHeight;
      setIsAtBottom(windowBottom >= footerTop);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  if (!isVisible || isAtBottom) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-3 z-40 flex justify-between" data-id="element-24">
      <Button variant="secondary" className="flex-1 mr-2 focus:ring-2 focus:ring-primary focus:ring-offset-2" onClick={() => scrollTo('pricing')} data-id="element-25">
        See pricing
      </Button>
      <Button variant="primary" className="flex-1 ml-2 focus:ring-2 focus:ring-primary focus:ring-offset-2" onClick={openCalendly} data-id="element-26">
        Speak with a Senior PM
      </Button>
    </div>;
};